import { useExperiment } from '@acp/feature/auth';
import { Experiment } from '@acp/shared';
import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { PropertyRequestCreatorContext } from '../create-request/creator-machine/context';

export function useAutoOpenPropertyRequestModal({
    queryParamName,
}: {
    queryParamName: string;
}) {
    const machine = PropertyRequestCreatorContext.useActorRef();
    const [searchParams] = useSearchParams();
    const { hasExperiment, isLoading } = useExperiment();

    const shouldModalOpen = useMemo(
        () => searchParams.get(queryParamName) === '1',
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [queryParamName]
    );

    useEffect(() => {
        if (
            isLoading
            || !hasExperiment(Experiment.PropertyRequestEnrolmentV1)
            || !shouldModalOpen
        ) {
            return;
        }

        machine.send({
            type: 'OPEN',
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldModalOpen, isLoading, hasExperiment]);
}
